import { getAsync, postAsync, putAsync, deleteAsync } from '../../api.service'

// Implements the @uppy/aws-s3 multipart hooks against one of our storage
// multipart endpoint groups. `base` = REACT_APP_API_STORAGE, `path` =
// 'api/v1/file-build-multipart' | 'api/v1/file-content-multipart',
// `initParams` = { appVersionID } | { assetID }. Our row id (assetVersionId)
// is used as Uppy's opaque `key`; every later endpoint is keyed by it.
export function createS3MultipartAdapter({ base, path, initParams }) {
  return {
    async createMultipartUpload(file) {
      // contentLength is the size storage holds the finished object to: content
      // multipart complete fails the version (integrity_failed) when S3's size
      // differs, so leaving it out declared 0 and failed every upload.
      const body = {
        ...initParams,
        filename: file.name,
        note: (file.meta && file.meta.note) || '',
        contentLength: file.size,
      }
      const res = await postAsync(base, `${path}/init`, body)
      const id = String(res.data.assetVersionId)
      return { uploadId: id, key: id }
    },
    async signPart(file, { key, partNumber }) {
      const res = await getAsync(base, `${path}/${key}/${partNumber}/presigned`)
      return { url: res.data.url }
    },
    async completeMultipartUpload(file, { key, parts }) {
      const body = parts.map(p => ({ partNumber: p.PartNumber, etag: p.ETag }))
      await putAsync(base, `${path}/${key}/complete`, body)
      return {}
    },
    async abortMultipartUpload(file, { key }) {
      await deleteAsync(base, `${path}/${key}/abort`)
    },
  }
}
